
<template>
  <div style="padding:20px;background:#fff;border-radius:10px;">
    <div>
      <div class="top-div">
        <h4 class="title"><span>北京市各地区货运平台入网车辆吨位分布统计-截止2019年3月31日</span></h4>
        <div class="privice-tiem">
            <!-- <span class="demonstration">统计月份 </span>
            <el-date-picker
              v-model="monTime"
              type="month"
              placeholder="选择月"
              @change="changeTime"
              value-format="yyyy-MM"
            ></el-date-picker> -->
            <el-button @click="goback">返回上一级</el-button>
            <el-button v-show="hideExport" >导出</el-button>
          </div>
        </div>
      <el-table ref="singleTable"  :data="tableData" height="500" stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号 "></el-table-column>
        <el-table-column property="name" label="入网地区" align="center"></el-table-column>
        <el-table-column property="total" label="入网车辆数"   align="center"></el-table-column>
        <el-table-column property="gaosu" align="center" label="10吨及以下入网车辆数"></el-table-column>
        <el-table-column property="guodao" label="10(不含)-25吨入网车辆数" align="center"x></el-table-column>
        <el-table-column property="guodao" label="25(不含)-35吨入网车辆数" width="160"></el-table-column>
        <el-table-column property="guodao" label="35吨(不含)以上入网车辆数" width="160"></el-table-column>
      </el-table>
      </div>
  </div>
</template>
<script>
import allData from './index.js'//所有数据
import { hideExport } from '@/utils/tools'
let i = 0
var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
  },
  data() {
    return {
       hideExport:hideExport,
      i: 0,
      monTime: now, // 默认月份
      tableData: allData
    }
  },
  props:{
  
  },
  watch: {
  },
  created() {
  },
  methods:{
    changeTime() {
      let that = this
      let time = that.monTime
      let year = time.getFullYear()
      let month = time.getMonth()
      that.endMonth = year + that.initMonth(month)
      // that.getData()
    },
    goback(){
      this.$emit("closeHtml")
    },
  }
}
</script>